import { TLegalPage } from '@/reseller/reseller.types';

export const LEGAL_PAGES: Record<TLegalPage, string> = {
  terms_and_conditions:
    'https://www.softwaredefinedautomation.io/terms-and-conditions/',
  data_processing_addendum:
    'https://www.softwaredefinedautomation.io/exhibit-c/',
};
